import { EBuildersLocationsActionType } from '../actions/buildersLocations';
import { EBuildersLocationsStatus, IBuildersLocations } from '../types/buildersLocations';
import { TReduxActions } from '../types/redux';

const defaultState: IBuildersLocations = {
  data: [],
  status: EBuildersLocationsStatus.Initial,
};

export const buildersLocationsReducer = (
  state: IBuildersLocations = defaultState,
  action: TReduxActions,
): IBuildersLocations => {
  switch (action.type) {
    case EBuildersLocationsActionType.StartFetching: {
      return {
        ...state,
        status: EBuildersLocationsStatus.Fetching,
      };
    }
    case EBuildersLocationsActionType.SetData:
      return {
        data: action.payload,
        status: EBuildersLocationsStatus.Success,
      };
    default:
      return state;
  }
};
